module.exports = __webpack_public_path__ + "static/media/dessert-image-2.3597813b.png";